import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { module } from 'angular';

import {
  ActivityContextFacade,
  ActivityFacade,
  ActivityReasonFacade,
  AgentChannelFacade,
  AgentConfigFacade,
  AgentMailFacade,
  AgentSkillFacade,
  AgentSystemFacade,
  AgentUserFacade,
  AppointmentFacade,
  BookingFacade,
  BookingMailFacade,
  BookingPhoneFacade,
  ConferenceFacade,
  DelegatorFacade,
  InterContactFacade,
  ListenFacade,
  MailUnitFacade,
  ParticipantFacade,
  PhoneUnitFacade,
  PlanningFacade,
  PositionFacade,
  QualificationFacade,
  QualificationFormComponent,
  QualificationService,
  RecordFacade,
  SmsFacade,
  SmsService,
  StmService,
  TransitionFacade,
  UserStmService,
} from '@contact/upgrade';

import Activity from './activity/activity.module.ajs';
import Agent from './agent/agent.module.ajs';
import Alert from './alert/alert.module.ajs';
import Basket from './basket/basket.module.ajs';
import ChannelDigit from './channel-digit/channel-digit.module.ajs';
import Booking from './contact/contact.module.ajs';
import KnowledgeBase from './knowledge-base/knowledge-base.module.ajs';
import Phone from './phone/phone.module.ajs';
import Search from './search/search.module.ajs';
import { DisplayModeService } from './settings/display-mode.service';

export default module('contact.agent.core', [Activity, Agent, Alert, Basket, ChannelDigit, Booking, KnowledgeBase, Phone, Search])
  // DOWNGRADE COMPONENT
  .directive('cngQualification', downgradeComponent({ component: QualificationFormComponent }) as angular.IDirectiveFactory)
  // DOWNGRADE SERVICE
  .factory('stmService', downgradeInjectable(StmService) as any)
  .factory('agentStatusService', downgradeInjectable(UserStmService) as any)
  .factory('smsService', downgradeInjectable(SmsService) as any)
  .factory('displayModeService', downgradeInjectable(DisplayModeService) as any)
  .factory('qualificationService', downgradeInjectable(QualificationService) as any)
  // STORE
  .factory('activityFacade', downgradeInjectable(ActivityFacade) as any)
  .factory('activityContextFacade', downgradeInjectable(ActivityContextFacade) as any)
  .factory('activityReasonFacade', downgradeInjectable(ActivityReasonFacade) as any)
  .factory('agentUserFacade', downgradeInjectable(AgentUserFacade) as any)
  .factory('agentChannelFacade', downgradeInjectable(AgentChannelFacade) as any)
  .factory('agentConfigFacade', downgradeInjectable(AgentConfigFacade) as any)
  .factory('agentSkillFacade', downgradeInjectable(AgentSkillFacade) as any)
  .factory('agentSystemFacade', downgradeInjectable(AgentSystemFacade) as any)
  .factory('contactFacade', downgradeInjectable(BookingFacade) as any)
  .factory('bookingMailFacade', downgradeInjectable(BookingMailFacade) as any)
  .factory('bookingPhoneFacade', downgradeInjectable(BookingPhoneFacade) as any)
  .factory('interContactFacade', downgradeInjectable(InterContactFacade) as any)
  .factory('listenFacade', downgradeInjectable(ListenFacade) as any)
  .factory('agentMailFacade', downgradeInjectable(AgentMailFacade) as any)
  .factory('mailUnitFacade', downgradeInjectable(MailUnitFacade) as any)
  .factory('phoneUnitFacade', downgradeInjectable(PhoneUnitFacade) as any)
  .factory('planningFacade', downgradeInjectable(PlanningFacade) as any)
  .factory('positionFacade', downgradeInjectable(PositionFacade) as any)
  .factory('qualificationFacade', downgradeInjectable(QualificationFacade) as any)
  .factory('recordFacade', downgradeInjectable(RecordFacade) as any)
  .factory('transitionFacade', downgradeInjectable(TransitionFacade) as any)
  .factory('appointmentFacade', downgradeInjectable(AppointmentFacade) as any)
  .factory('delegatorFacade', downgradeInjectable(DelegatorFacade) as any)
  .factory('participantFacade', downgradeInjectable(ParticipantFacade) as any)
  .factory('conferenceFacade', downgradeInjectable(ConferenceFacade) as any)
  .factory('smsFacade', downgradeInjectable(SmsFacade) as any).name;
